import { useCallback, useState } from "react";
import { captureScreenshot } from "@/lib/screenshotCapture";
import { getConsoleLogs, type ConsoleLogEntry } from "@/lib/consoleCapture";

export function useFeedbackCapture() {
  const [isCapturing, setIsCapturing] = useState(false);
  const [screenshot, setScreenshot] = useState<Blob | null>(null);
  const [consoleLogs, setConsoleLogs] = useState<ConsoleLogEntry[]>([]);

  const captureAll = useCallback(
    async (options?: { hideSelectors?: string[] }) => {
      setIsCapturing(true);
      try {
        setConsoleLogs(getConsoleLogs());

        const blob = await captureScreenshot({
          quality: 0.8,
          scale: 1,
          hideSelectors: options?.hideSelectors,
        });
        setScreenshot(blob);

        return { screenshot: blob, consoleLogs: getConsoleLogs() };
      } finally {
        setIsCapturing(false);
      }
    },
    [],
  );

  const clear = useCallback(() => {
    setScreenshot(null);
    setConsoleLogs([]);
  }, []);

  return {
    isCapturing,
    screenshot,
    consoleLogs,
    setScreenshot,
    setConsoleLogs,
    captureAll,
    clear,
  };
}
